import { InfoBoxTitle, InfoBoxWrapper } from "../Styled";
import { NoticeText } from "./Styled";

interface UploadFilesProps {
    materialRequestId?: string;
    customerId?: string;
}

const Upload = ({ materialRequestId, customerId }: UploadFilesProps) => {
    return (
        <InfoBoxWrapper>
            <InfoBoxTitle>Tải lên tài liệu đính kèm</InfoBoxTitle>
            <NoticeText>Tính năng tải lên tệp tin cho Phiếu yêu cầu vật tư chưa được triển khai.</NoticeText>
        </InfoBoxWrapper>
    );
};

export default Upload;
